import {enablePreloaderInItem, disablePreloaderInItem} from 'component/preloader';
const Promise = require('bluebird');
const config = require('./config.yaml')[templateVars.lang];

function getInteractJSModule(callback) {
	require.ensure(['interactjs'], function (require) {
		callback(require('interactjs'));
	});
}


/**
 * Класс для управления компонента логистической карты
 */
class LogisticMapController {
	constructor() {
		this.config = config; //конфиг компонента
		this.triggerActiveClass = 'is-active'; //класс для выставления у активного триггера ссылки
		this.filterTriggerDataAttributeName = 'data-filter-id'; //data-атрибут для триггеров фильтра
		this.zoomTriggerDataAttributeName = 'data-zoom-trigger-type'; //data-атрибут для триггеров зума
		this.interactInstance = null; //инстанс для interact-объекта
		this.$globalWrapper = $('#logistic-map-wrapper'); //глобальный контейнер с картой
		this.minWindowHeight = 600; //минимальная высота окна без прокрутки

		// Соотвношение уровня зума показателю в конфиге
		this.zoomFactorMap = {
			1: 'zoomx1',
			2: 'zoomx2'
		};

		if (this.$globalWrapper.length) {
			getInteractJSModule((interact) => {
				this.interactPlugin = interact; //фильтры-ссылки
				this.$layersWrapper = $('#logistic-map-layers-wrapper'); //контейнер для слоев
				this.$imageWrapper = $('#logistic-map-image-wrapper'); //контейнер с изображением
				this.$image = $('#logistic-map-image'); //изображение
				this.$filtersWrapper = $('#logistic-map-filters'); //контейнер с фильтрами
				this.$filterTriggers = this.$filtersWrapper.find(`[${this.filterTriggerDataAttributeName}]`); //фильтры-ссылки
				this.$zoomWrapper = $('#logistic-map-zoom-panel'); //контейнер с зумом
				this.$zoomTriggers = this.$zoomWrapper.find(`[${this.zoomTriggerDataAttributeName}]`); // триггеры зума
				this.$customScrollBlocks = this.$globalWrapper.find('[data-custom-scrollbar]'); // блоки для кастомизации скролла

				this.setWrapperHeight(() => {
					this.lock();
					this.$globalWrapper.show();

					this.initCustomScrollbar();

					// создаем инстанс interact
					this.createInteractInstance();
					// провешиваем обработчики на клик по элементам фильтра
					this.initFilterChangeEvent();
					// провешиваем обработчики на клики по кнопкам зума
					this.initZoomClickEvent();

					this.setWrapperHeight();

					this.preloadImagesFromConfig()
						.then(() => {
							this.unlock();
						});
				});
			});
		}
	}

	initCustomScrollbar() {
		$.each(this.$customScrollBlocks, (i, item) => {
			const $that = $(item);
			const type = $that.attr('data-custom-scrollbar-type');

			switch (type) {
				case 'accordion':
					$that.height($that.outerHeight());
					break;
				default:
			}

			$that.mCustomScrollbar({
				axis: 'yx',
				theme: 'nornikel',
				mouseWheel: {
					enable: true
				},
				advanced: {
					updateOnBrowserResize: true,
					updateOnContentResize: true
				}
			});

			$that.mCustomScrollbar('scrollTo', 'first', {
				scrollInertia: 500
			});
		});
	}

	/**
	 * Обработчик события на событие click триггеров фильтра
	 */
	initFilterChangeEvent() {
		//для каждой ссылки-фильтра
		this.$filterTriggers.each((key, item) => {
			let $item = $(item);

			$item.on('change', () => {
				const $filter1 = this.$filterTriggers.filter('[data-filter-id="filter1"]');
				const $filter2 = this.$filterTriggers.filter('[data-filter-id="filter2"]');
				const $filterAll = this.$filterTriggers.filter('[data-filter-id="filterAll"]');
				const isFilter1Checked = $filter1.prop('checked') == true;
				const isFilter2Checked = $filter2.prop('checked') == true;
				const isFilterAllChecked = $filterAll.prop('checked') == true;

				if ($item.attr('id') == 'filterAll') {
					if (isFilterAllChecked) {
						this.$filterTriggers.prop('checked', true);
					} else {
						this.$filterTriggers.prop('checked', false);
					}
				} else {
					if (isFilter1Checked && isFilter2Checked) {
						$filterAll.prop('checked', true);
					} else {
						$filterAll.prop('checked', false);
					}
				}

				let imagesLinks = this.getImageLinksByFilters(); //объект со ссылками на изображения для выставления по фильтра

				//проверяем, что ссылки получены
				if (this.isValidImagesConfig(imagesLinks)) {
					//получить показатель зума
					const zoomFactor = this.getCurrentZoomFactor();

					// выставляем картинку в зависимости от показателя зума
					this.setImageParams(imagesLinks, this.zoomFactorMap[zoomFactor], () => {

					});
				}
			});
		});
	}

	/**
	 * Возвращает картинки для вывода по активным фильтрам
	 * @returns {{}}
	 */
	getImageLinksByFilters() {
		const $filter1 = this.$filterTriggers.filter('[data-filter-id="filter1"]');
		const $filter2 = this.$filterTriggers.filter('[data-filter-id="filter2"]');
		const isFilter1Checked = $filter1.prop('checked') == true;
		const isFilter2Checked = $filter2.prop('checked') == true;
		let imagesLinks = {};

		if (isFilter1Checked && isFilter2Checked) {
			imagesLinks = this.getImagesFromConfigByFilter('filter3');
		} else if (isFilter1Checked) {
			imagesLinks = this.getImagesFromConfigByFilter('filter1');
		} else if (isFilter2Checked) {
			imagesLinks = this.getImagesFromConfigByFilter('filter2');
		} else {
			imagesLinks = this.getDefaultImagesFromConfig();
		}

		return imagesLinks;
	}

	/**
	 * Обработчик события на событие click триггеров зума
	 */
	initZoomClickEvent() {
		//для каждой кнопки зума
		this.$zoomTriggers.each((key, item) => {
			let $item = $(item);

			$item.on('click touch', () => {
				if (this.isLock()) {
					return false;
				}

				// кнопка заблокирована
				if ($item.hasClass('is-disabled')) {
					return false;
				} else { // иначе
					// определяем тип кнопки
					const zoomBtnType = $item.attr('data-zoom-trigger-type');

					// если увеличить
					if (zoomBtnType == 'increase') {
						const $decreaseBtn = this.$zoomTriggers.filter((i, item) => {
							return $(item).attr('data-zoom-trigger-type') == 'decrease';
						});

						// вызов увеличени зума
						this.increaseMapZoom((increaseBtnDisabled, decreaseBtnDisabled) => {
							if (increaseBtnDisabled) {
								$item.addClass('is-disabled');
							} else {
								$item.removeClass('is-disabled');
							}

							if (decreaseBtnDisabled) {
								$decreaseBtn.addClass('is-disabled');
							} else {
								$decreaseBtn.removeClass('is-disabled');
							}
						});
					} else if (zoomBtnType == 'decrease') { // если уменьшить
						const $increaseBtn = this.$zoomTriggers.filter((i, item) => {
							return $(item).attr('data-zoom-trigger-type') == 'increase';
						});

						// вызов уменьшения зума
						this.decreaseMapZoom((increaseBtnDisabled, decreaseBtnDisabled) => {
							if (decreaseBtnDisabled) {
								$item.addClass('is-disabled');
							} else {
								$item.removeClass('is-disabled');
							}

							if (increaseBtnDisabled) {
								$increaseBtn.addClass('is-disabled');
							} else {
								$increaseBtn.removeClass('is-disabled');
							}
						});
					}
				}

				return false;
			});
		});
	}

	/**
	 * Приближает значение карты на одно значение, если это возможно
	 */
	increaseMapZoom(callback) {
		// Получить текущий зум
		const currentZoomLevel = Number(this.getCurrentZoomFactor());
		// Получить уровень последующего зума
		const nextZoomLevel = currentZoomLevel + 1;

		// Есть ли следующий зум в мэп-карте
		if (typeof this.zoomFactorMap[nextZoomLevel] != 'undefined') {
			let imagesLinks = this.getImageLinksByFilters();

			//проверяем, что ссылки получены
			if (this.isValidImagesConfig(imagesLinks)) {
				// выставляем картинку в зависимости от показателя зума
				this.setImageParams(imagesLinks, this.zoomFactorMap[nextZoomLevel], () => {
					this.$imageWrapper.attr('data-zoom', nextZoomLevel);
					this.resetMapPosition();

					callback(true, false);
				});
			}
		} else {
			return false;
		}
	}

	/**
	 * Отдаляет значение карты на одно значение, если это возможно
	 */
	decreaseMapZoom(callback) {
		// Получить текущий зум
		const currentZoomLevel = Number(this.getCurrentZoomFactor());
		// Получить уровень последующего зума
		const prevZoomLevel = currentZoomLevel - 1;

		// Есть ли следующий зум в мэп-карте
		if (typeof this.zoomFactorMap[prevZoomLevel] != 'undefined') {
			let imagesLinks = this.getImageLinksByFilters();

			//проверяем, что ссылки получены
			if (this.isValidImagesConfig(imagesLinks)) {
				// выставляем картинку в зависимости от показателя зума
				this.setImageParams(imagesLinks, this.zoomFactorMap[prevZoomLevel], () => {
					this.$imageWrapper.attr('data-zoom', prevZoomLevel);
					this.resetMapPosition();

					callback(false, true);
				});
			}
		} else {
			return false;
		}
	}

	/**
	 * Возвращает текущее значение zoom-фактора карты
	 * @returns {string}
	 */
	getCurrentZoomFactor() {
		return this.$imageWrapper.attr('data-zoom');
	}

	/**
	 * Возвращает значение ID текущего активного фильтра
	 */
	getCurrentFilterID() {
		const $currentTrigger = this.$filterTriggers.filter(`.${this.triggerActiveClass}`);

		return ($currentTrigger.length) ? $currentTrigger.attr(this.filterTriggerDataAttributeName) : false;
	}

	/**
	 * Возвращает дефолтные картинки карты без фильтров
	 * @returns {{zoomx1, zoomx2}}
	 */
	getDefaultImagesFromConfig() {
		return {
			zoomx1: this.config['layers'][this.zoomFactorMap[1]]['map'],
			zoomx2: this.config['layers'][this.zoomFactorMap[2]]['map']
		};
	}

	/**
	 * Возвращает изображения карт по переданному фильтру
	 * @param filterID
	 */
	getImagesFromConfigByFilter(filterID) {
		return {
			zoomx1: this.config['layers'][this.zoomFactorMap[1]][filterID],
			zoomx2: this.config['layers'][this.zoomFactorMap[2]][filterID]
		};
	}

	/**
	 * Проверяет переданный конфиг на заполненность всех необходимых полей
	 */
	isValidImagesConfig(imagesLinks) {
		return imagesLinks
			&& imagesLinks[this.zoomFactorMap[1]]
			&& imagesLinks[this.zoomFactorMap[2]];
	}

	/**
	 * Заменяет у картинки атрибуты с путями по переданному конфигу
	 * @param imagesLinks
	 * @param zoomFactor
	 * @param callback - вызов после окончания анимации
	 */
	setImageParams(imagesLinks, zoomFactor = this.zoomFactorMap[1], callback = () => {}) {
		if (this.isValidImagesConfig(imagesLinks)) {
			this.lock();

			this.$image.velocity('fadeOut', config.changeMapAnimationSpeed, () => {
				this.$image
					.attr('src', imagesLinks[zoomFactor]);

				this.$image.velocity('fadeIn', config.changeMapAnimationSpeed, () => {
					this.unlock();
					callback();
				});
			});
		}
	}

	/**
	 * Сброс положения карты
	 */
	resetMapPosition() {
		this.$imageWrapper.attr('data-x', 0);
		this.$imageWrapper.attr('data-y', 0);

		this.$imageWrapper[0].style.webkitTransform =
			this.$imageWrapper[0].style.transform =
				`translate(0px, 0px)`;
	}

	/**
	 * Инициализирует interact-плагин для блока с изображением
	 */
	createInteractInstance() {
		//записываем инстанс в переменную класса
		this.interactInstance = this.interactPlugin(this.$imageWrapper[0])
			.draggable({
				// // enable inertial throwing
				inertia: false,
				restrict: {
					restriction: 'parent',
					endOnly: true,
					//elementRect: {top: 0, left: 1, bottom: 0, right: 1}
				},
				autoScroll: true,
				onmove: dragMoveListener,
			});

		function dragMoveListener(event) {
			const target = event.target;
			// keep the dragged position in the data-x/data-y attributes
			const currentX = (parseFloat(target.getAttribute('data-x')) || 0);
			const currentY = (parseFloat(target.getAttribute('data-y')) || 0);

			let x = currentX + event.dx;
			let y = currentY + event.dy;

			if (x >= 0) {
				x = currentX;
			} else if (x < 0) {
				this.$layersWrapper = $('#logistic-map-layers-wrapper'); //контейнер для слоев
				this.$imageWrapper = $('#logistic-map-image-wrapper'); //контейнер с изображением

				let a = this.$layersWrapper.width();
				let b = this.$imageWrapper.width() + x;

				if (a > b) {
					x = currentX;
				}
			}

			if (y >= 0) {
				y = currentY;
			} else if (y < 0) {
				this.$layersWrapper = $('#logistic-map-layers-wrapper'); //контейнер для слоев
				this.$imageWrapper = $('#logistic-map-image-wrapper'); //контейнер с изображением

				let a = this.$layersWrapper.height();
				let b = this.$imageWrapper.height() + y;

				if (a > b) {
					y = currentY;
				}
			}

			// translate the element
			target.style.webkitTransform =
				target.style.transform =
					`translate(${x}px, ${y}px)`;

			// update the posiion attributes
			target.setAttribute('data-y', y);
			target.setAttribute('data-x', x);
		}

		// this is used later in the resizing and gesture demos
		window.dragMoveListener = dragMoveListener;

		$(window).on('resize', () => {
			this.setWrapperHeight();
			this.resetMapPosition();
		});
	}

	/**
	 * Подгрузка всех изображений из конфига в DOM, что бы не подгружать во время смены атрибутов у
	 * основной картинки
	 *
	 * @returns {*}
	 */
	preloadImagesFromConfig() {
		let listLinks = []; //массив для хранения урлов для обхода

		for (let size in this.config.layers) {
			for (let id in this.config.layers[size]) {
				listLinks.push(this.config.layers[size][id]);
			}
		}

		//промис разресолвится после загрузки всех изображений
		return Promise.resolve(listLinks)
			.map(url => {
				return new Promise((resolve, reject) => {
					let img = document.createElement('img');

					img.src = url;
					img.onload = resolve;
				});
			});
	}

	/**
	 * Расчет и выставление высоты блока с картой
	 * @param callback
	 */
	setWrapperHeight(callback = () => {}) {
		const headerHeight = $('.wrapper--header').outerHeight();
		const footerHeight = $('.wrapper--footer .footer').outerHeight();

		if ($(window).height() > this.minWindowHeight) {
			const workareaHeight = $(window).height() - headerHeight - footerHeight;
			this.$layersWrapper.height(workareaHeight);
		}

		callback();
	}

	/**
	 * Блокировка карты
	 */
	lock() {
		enablePreloaderInItem(this.$globalWrapper);
	}

	/**
	 * Разблокировка карты
	 */
	unlock() {
		disablePreloaderInItem(this.$globalWrapper);
	}

	/**
	 * Проверить, заблокирована ли карта
	 * @returns {boolean}
	 */
	isLock() {
		return Boolean(this.$globalWrapper.hasClass('preloader'));
	}
}

$(document).ready(() => {
	const mapController = new LogisticMapController();
});


// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
	Object.keys = (function () {
		'use strict';
		let hasOwnProperty = Object.prototype.hasOwnProperty,
			hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
			dontEnums = [
				'toString',
				'toLocaleString',
				'valueOf',
				'hasOwnProperty',
				'isPrototypeOf',
				'propertyIsEnumerable',
				'constructor'
			],
			dontEnumsLength = dontEnums.length;

		return function (obj) {
			if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
				throw new TypeError('Object.keys called on non-object');
			}

			let result = [], prop, i;

			for (prop in obj) {
				if (hasOwnProperty.call(obj, prop)) {
					result.push(prop);
				}
			}

			if (hasDontEnumBug) {
				for (i = 0; i < dontEnumsLength; i++) {
					if (hasOwnProperty.call(obj, dontEnums[i])) {
						result.push(dontEnums[i]);
					}
				}
			}
			return result;
		};
	}());
}



// WEBPACK FOOTER //
// ./temp/components/logistic-map/index.js